import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { faItchIo } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* add icons to the library */
library.add(faItchIo)
library.add(faTwitter)
library.add(faGithub)
library.add(faEnvelope)
library.add(faLinkedin)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#404D6F",
        secondary: "#758bc3",
        accent: "758bc3",
        error: "#404D6F",
        background: "#404D6F", // Not automatically applied
      },
      dark: {
        primary: "#404D6F",
        background: "#404D6F", // If not using lighten/darken, use base to return hex
      },
    },
  },
});
